import React, { Component } from 'react';
import Store from '../../../../redux/Store';
import SystemAlertsConfiguration from './SystemAlertsConfiguration';
import Constants from '../../../../common/constants/Constants';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import {
  getSystemAlertConfigList,
  updateSystemAlertConfig,
} from './SystemAlertsConfiguration.actions';

class SystemAlertsConfigurationContainer extends Component {
  constructor() {
    super();

    this.state = {
      alerts: [],
    };

    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.refreshPage();
  }

  render() {
    return <SystemAlertsConfiguration alerts={this.state.alerts} onChange={this._onChange} />;
  }

  _onChange(id, v, setting) {
    const tempAlerts = this.state.alerts.slice(0);
    const alert = tempAlerts.find((a) => a.id === id);
    alert.pending = true;
    this.setState({ alerts: tempAlerts });

    updateSystemAlertConfig(id, v, setting)
      .then((res) => {
        this._updateStateWithNewDataset(res);
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'Successfully updated alert settings',
          })
        );
      })
      .catch((err) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed updating alert settings',
          })
        );
      });
  }

  refreshPage() {
    getSystemAlertConfigList().then((res) => this._updateStateWithNewDataset(res));
  }

  _updateStateWithNewDataset(res) {
    const alertData = res.body;
    const alerts = Object.keys(alertData).map((k) => ({
      id: k,
      settings: Object.keys(alertData[k].Settings)
        .filter((ks) => ks.startsWith('InputSetting_'))
        .map((ks) => `${ks.replace('InputSetting_', '')}: ${alertData[k].Settings[ks]}`)
        .join('; '),
      name: alertData[k].Settings.DisplayName,
      enabled: alertData[k].Settings.Enabled,
      emailNotifications: alertData[k].Settings.EmailNotifications.toString().match(/true/i)
    }));
    this.setState({
      alerts,
    });
  }
}

export default SystemAlertsConfigurationContainer;
